import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AbsentProxyReportLayer from "../components/AbsentProxyReportLayer";

const AbsentProxyReportPage = () => {
    return (
        <MasterLayout>
            <AbsentProxyReportLayer />
        </MasterLayout>
    );
};

export default AbsentProxyReportPage;
